<template>
    <modal name="user-modal" :adaptive="true" :height="'auto'" @before-open="onModalShow">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="InputNewUsername">Matricola *</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <strong class="input-group-text">IT</strong>
                                        </div>
                                        <input
                                            :readonly="currentUser.id === user.id"
                                            maxlength="6"
                                            id="InputNewUsername"
                                            type="text"
                                            v-model="user.username"
                                            class="form-control"
                                            placeholder="Numero matricola"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group" v-if="currentUser.type === 1">
                                    <label>Tipologia *</label>
                                    <select class="form-control" v-model="user.type" required>
                                        <option :value="null" disabled>-- Seleziona tipologia di utente --</option>
                                        <option value="1">Admin</option>
                                        <option value="2">Utente</option>
                                        <!-- <option value="3">Gruppo di utenti</option> -->
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Email *</label>
                                    <input type="email" name="email" v-model="user.email" class="form-control" required />
                                </div>
                                <!-- <div class="form-group">
                                    <label>Codice identificativo</label>
                                    <input type="number" name="number" v-model="user.number" class="form-control" />
                                </div> -->
                                <!-- <div class="form-group" v-if="user.type === 2 && currentUser.type === 1">
                                    <label>Gruppo (facoltativo)</label>
                                    <select class="form-control" v-model="user.parent">
                                        <option :value="null" disabled>-- Seleziona il gruppo --</option>
                                        <option v-for="group in groupsUsers" :key="group.id" :value="group.id">
                                            {{ group.username }}
                                        </option>
                                    </select>
                                </div> -->
                            </div>
                        </div>
                        <!-- Server Errors -->
                        <div class="alert alert-danger" v-if="hasRegistrationErrors">
                            <span class="d-block" v-for="(error, i) in registrationErrors" :key="i">
                                <b>{{ i.replace('username', 'matricola') }}</b> <span v-for="(e, ie) in error" :key="ie">{{ e }}<br/></span>
                            </span>
                        </div>
                        <!-- Client Errors -->
                        <div v-if="$v.$error" class="alert alert-danger mb-0">
                            <span v-if="!$v.username.required">Il campo <i>Matricola</i> è richiesto.<br></span>
                            <span v-if="!$v.username.minLength">Il campo <i>Matricola</i> dev'essere lungo 6 caratteri.<br></span>
                            <span v-if="!$v.username.maxLength">Il campo <i>Matricola</i> dev'essere lungo 6 caratteri.<br></span>
                            <span v-if="!$v.username.numeric">Il campo <i>Matricola</i> dev'essere un numero.<br></span>
                            <span v-if="!$v.user.email.required || !$v.user.email.email">Un indirizzo email valido è richiesta.<br></span>
                            <span v-if="!$v.user.type.required">Seleziona il tipo di utente.<br></span>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" class="btn btn-success" @click="saveuser">
                            <font-awesome-icon :icon="['far','save']"></font-awesome-icon>&nbsp;SALVA
                        </button>
                        <button type="button" class="btn btn-light" @click="closeModal">
                            <font-awesome-icon icon="times"></font-awesome-icon>&nbsp;ANNULLA
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import {
    User
} from '@/models/User'
import {
    email,
    required,
    maxLength,
    minLength,
    numeric
} from 'vuelidate/lib/validators'
import {
    mapGetters,
    mapState
} from 'vuex'
import {
    GET_LIST,
    CREATE,
    GET_SINGLE
} from '@/store/actions.type'
import {
    MODULE_NAME as USERS_MODULE_NAME
} from '@/store/modules/users.module'

export default {
    name: 'user-modal',
    data () {
        return {
            hasRegistrationErrors: false
        }
    },
    props: {
        user: {
            type: Object
        }
    },
    validations: {
        user: {
            username: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(6),
                numeric
            },
            email: {
                required,
                email
            },
            type: {
                required
            }
        }
    },
    computed: {
        computedUsers () {
            var _users = []
            for (var i = 0; i < this.allUsers.length; i++) {
                var type = this.allUsers[i].type === 1 ? 'Admin' : this.allUsers[i].type === 2 ? 'User' : 'Group'
                var u = {
                    value: this.allUsers[i].id,
                    text: this.allUsers[i].email + ' (' + type + ')'
                }
                _users.push(u)
            }
            return _users
        },
        groupsUsers () {
            var _groups = []
            _groups = this.allUsers.filter((u) => {
                return u.type === 3
            })
            return _groups
        },
        ...mapState({
            registrationErrors: state => state.USERS.errors
        }),
        ...mapGetters([
            'currentUser'
        ]),
        ...mapGetters({
            users: `${USERS_MODULE_NAME}/getList`,
            single: `${USERS_MODULE_NAME}/getSingle`
        }),
        allUsers () {
            return this.users.data || []
        },
        localUser () {
            return this.user
        },
        // hasRegistrationErrors () {
        //     return Object.keys(this.registrationErrors).length !== 0 && this.registrationErrors.constructor === Object
        // }
    },
    methods: {
        closeModal () {
            this.$modal.hide('user-modal')
        },
        onModalShow () {
            this.$v.$reset()
            if (this.user.id) this.fetchSingle()
        },
        fetchSingle () {
            this.$store.dispatch(`${USERS_MODULE_NAME}/${GET_SINGLE}`, {
                id: this.user.id
            }).then(() => {
                this.user = this.single
            })
        },
        fetchUsers () {
            this.$store.dispatch(`${USERS_MODULE_NAME}/${GET_LIST}`, {
                query: {}
            })
        },
        saveuser () {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                let _user = new User()
                _user.username = `IT${this.user.username}`
                _user.email = this.user.email
                _user.created_by = this.currentUser.id
                this.$store.dispatch(`${USERS_MODULE_NAME}/${CREATE}`, _user).then((data) => {
                    if (data.status === 200) {
                        this.$swal('Ben fatto!', '', 'success')
                        this.$store.dispatch(`${USERS_MODULE_NAME}/${GET_LIST}`, {})
                        this.closeModal()
                    }
                }).catch((e) => {
                    console.log(e)
                    this.hasRegistrationErrors = e
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.uploader-wrapper {
    position: relative;
    img {
        display: block;
        margin: auto;
        transition: opacity .3s;
    }
    input {
        cursor: pointer;
        display: block;
        height: 100%;
        left: 0;
        opacity: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 999;
    }
    svg {
        display: block;
        height: 40px;
        left: calc( 50% - 20px );
        opacity: 0;
        position: absolute;
        transition: opacity .3s;
        top: calc( 50% - 20px );
        width: 40px;
        z-index: 99;
    }
    &:hover {
        img {
            opacity: .5;
        }
        svg {
            opacity: 1;
        }
    }
}
</style>
